var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff6a61",
    viewBox: "-7.41 -7.41 33.82 33.82",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cf-icon-svg",
    stroke: "#ff6a61",
    strokeWidth: 0.34199999999999997,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.26 16.151h-.043a4.012 4.012 0 0 1-2.809-1.182L1.667 8.227a2.799 2.799 0 0 1 0-3.954l.065-.065a2.799 2.799 0 0 1 3.954 0l6.855 6.856a1.752 1.752 0 1 1-2.478 2.478L5.424 8.903a.554.554 0 0 1 .784-.784l4.639 4.64a.644.644 0 1 0 .91-.912L4.903 4.991a1.694 1.694 0 0 0-2.386 0l-.066.066a1.694 1.694 0 0 0 0 2.386l6.742 6.742a2.908 2.908 0 0 0 2.037.858h.031a2.76 2.76 0 0 0 2.782-2.814 2.91 2.91 0 0 0-.858-2.037l-7.03-7.03a.554.554 0 1 1 .784-.783l7.03 7.03a4.01 4.01 0 0 1 1.183 2.809 3.868 3.868 0 0 1-3.89 3.933z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.325e90ec8c533d901a412f2697c389b7.svg";
export { ForwardRef as ReactComponent };